import { Badge, BadgeProps } from "@mantine/core";

const regMarkMapping: Record<string, { label: string; color: string }> = {
    "P": { label: "Present", color: "green" },
    "L": { label: "Late", color: "orange" },
    "A": { label: "Absent", color: "red" },
    "E": { label: "Educational absence", color: "gray" },
    "X": { label: "Not required", color: "gray" },
}

export const RegMarkBadge: React.FC<{ regMark: string | null, fullLabel?: boolean, badgeProps?: BadgeProps }> = ({ regMark, fullLabel = false, badgeProps }) => {
    const mapping = regMark ? regMarkMapping[regMark] || { label: regMark, color: 'gray' } : { label: "Not taken", color: 'gray' };
    return (
        <Badge tt={'none'} fw={400} size="xs" variant="light" color={mapping.color} className="pointer-events-none" {...badgeProps}>
            {regMark ? fullLabel ? mapping.label : regMark : fullLabel ? "Not taken" : "-"}
        </Badge>
    );
}